import React from "react";
import { Form, Input } from "antd";

const { TextArea } = Input;

function NarrativeSection() {
  return (
    <>
      <div className="custom-title !bg-white !p-0 mt-[1.25rem]">Challenges</div>
      <Form.Item
        name="mrChallenges"
        label={"Describe"}
        rules={[
          {
            required: true,
            message: "Please add describe",
          },
        ]}
      >
        <TextArea className="text_area" />
      </Form.Item>

      <div className="custom-title !bg-white !p-0 mt-[1.25rem]">Remarks</div>
      <Form.Item
        name="mrRemarks"
        label={"Describe"}
        rules={[{ required: true, message: "Please add remarks" }]}
      >
        <TextArea className="text_area" />
      </Form.Item>

      <div className="custom-title !bg-white !p-0 mt-[1.25rem]">
        Work Projection for Next Month
      </div>
      <Form.Item
        name="mrWorkProjection"
        label={"Describe"}
        rules={[
          { required: true, message: "Please add work projection for next month" },
        ]}
      >
        <TextArea className="text_area" />
      </Form.Item>

      <div className="custom-title !bg-white !p-0 mt-[1.25rem]">
        Contractor Mobilization (in terms of materials, equipment, staff etc)
      </div>
      <Form.Item
        name="mrContractorMobilization"
        label={"Describe"}
        rules={[
          {
            required: true,
            message: "Please add contractor mobilization",
          },
        ]}
      >
        <TextArea className="text_area" />
      </Form.Item>
    </>
  );
}

export default NarrativeSection;
